import { render, staticRenderFns } from "./category.vue?vue&type=template&id=1a98b932&scoped=true"
import script from "./category.vue?vue&type=script&lang=js"
export * from "./category.vue?vue&type=script&lang=js"
import style0 from "./category.vue?vue&type=style&index=0&id=1a98b932&prod&scoped=true&lang=scss"
import style1 from "./category.vue?vue&type=style&index=1&id=1a98b932&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a98b932",
  null
  
)

export default component.exports